import Vue from 'vue'
import VueRouter from 'vue-router'
import MajorManage from '../views/MajorManage.vue'
import CategoryManage from '../views/CategoryManage.vue'
import CollegeManage from '../views/CollegeManage.vue'
import StudentManage from '../views/StudentManage.vue'
import ClassManage from '../views/ClassManage.vue'
import CourseManage from '../views/CourseManage.vue'
import HomeworkManage from '../views/HomeworkManage.vue'
import HomeworkAnswerManage from '../views/HomeworkAnswerManage.vue'
import DictManage from '../views/DictManageV2.vue'
import UpgradeMajorManage from '../views/UpgradeMajorManage.vue'
import UpgradeScoreLineManage from '../views/UpgradeScoreLineManage.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/student'
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/student',
    name: 'StudentManage',
    component: StudentManage
  },
  {
    path: '/class',
    name: 'ClassManage',
    component: ClassManage
  },
  // 学校路由
  {
    path: '/college/list',
    name: 'CollegeList',
    component: CollegeManage
  },
  {
    path: '/college/add',
    name: 'CollegeAdd',
    component: CollegeManage
  },
  // 兼容旧路由
  {
    path: '/college',
    redirect: '/college/list'
  },
  // 课程路由
  {
    path: '/course/upload',
    name: 'CourseUpload',
    component: CourseManage
  },
  {
    path: '/course/list',
    name: 'CourseList',
    component: CourseManage
  },
  // 兼容旧路由
  {
    path: '/course',
    redirect: '/course/list'
  },
  // 作业路由
  {
    path: '/homework/upload',
    name: 'HomeworkUpload',
    component: HomeworkManage
  },
  {
    path: '/homework/list',
    name: 'HomeworkList',
    component: HomeworkManage
  },
  {
    path: '/homework/answer',
    name: 'HomeworkAnswer',
    component: HomeworkAnswerManage
  },
  // 兼容旧路由
  {
    path: '/homework',
    redirect: '/homework/list'
  },
  // 字典管理路由
  {
    path: '/dict',
    name: 'DictManage',
    component: DictManage
  },
  // 专升本专业管理路由
  {
    path: '/upgrade-major',
    name: 'UpgradeMajorManage',
    component: UpgradeMajorManage
  },
  // 专升本分数线管理路由
  {
    path: '/upgrade-score-line',
    name: 'UpgradeScoreLineManage',
    component: UpgradeScoreLineManage
  },
  // 保留旧的路由以防万一
  {
    path: '/major',
    name: 'MajorManage',
    component: MajorManage
  },
  {
    path: '/category',
    name: 'CategoryManage',
    component: CategoryManage
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  // 如果访问登录页，已登录则跳转到首页
  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else {
    // 访问其他页面，未登录则跳转到登录页
    if (!token) {
      next('/login')
    } else {
      next()
    }
  }
})

export default router
